import { render, staticRenderFns } from "./ItemDisplay.vue?vue&type=template&id=2f67cf7d&scoped=true"
import script from "./ItemDisplay.vue?vue&type=script&lang=js"
export * from "./ItemDisplay.vue?vue&type=script&lang=js"
import style0 from "./ItemDisplay.vue?vue&type=style&index=0&id=2f67cf7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f67cf7d",
  null
  
)

export default component.exports